import $ from 'jquery';
import 'slick-carousel';

const OfferSlider = () => {
  const offer = $('.offers-container');

  offer.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });
};

export default OfferSlider;
